// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__yEgVW","modal-wrapper":"Modal_modal-wrapper__gj0Ye"};